export default '/build/85e1ed48.svg'